import "firebase/firestore";

export const initialize = () => {}; // firebase.initializeApp(config);
